import { useState } from "react";
import { NotificationManager } from "react-notifications";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { useFiltrosReporteProduccion } from "../../hooks/useFiltrosReporteProduccion";
import { ReporteCierresMensualesApi } from "../api/ReporteCierresMensualesApi";
import { TIPO_LABORATORIO } from "../helpers/tiposReporteCierres";

const STORAGE_KEY_FILTROS = "reporte_cierres_mensuales_prod";
const STORAGE_KEY_TIPO = "reporte_cierres_mensuales_prod_tipo";

// Una sola consulta trae las versiones de laboratorio y de liquidación; el tipo
// solo elige cuál se muestra. Cambiar un filtro limpia lo consultado, porque ya
// no corresponde a lo que indican los filtros
export const useReporteCierresMensuales = () => {
    const {
        getReporteCierresMensuales,
        descargarCierresMensualesExcel,
        cargando,
    } = ReporteCierresMensualesApi();

    const [reporte, setReporte] = useState(null);
    const [mensajeError, setMensajeError] = useState("");
    const [tipo, setTipo] = useState(
        sessionStorage.getItem(STORAGE_KEY_TIPO) || TIPO_LABORATORIO,
    );

    const ConsultarReporte = async (params) => {
        try {
            setMensajeError("");

            setReporte(await getReporteCierresMensuales(params));
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el reporte de cierres mensuales",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setReporte(null);
            setMensajeError(errorMsg);
        }
    };

    const DescargarExcel = async (params) => {
        try {
            await descargarCierresMensualesExcel(params);
        } catch (error) {
            NotificationManager.error(
                getErrorFromResponse(
                    error,
                    "Error al exportar el reporte de cierres mensuales",
                ),
                "Error",
                3000,
            );
        }
    };

    const LimpiarConsulta = () => {
        setReporte(null);
        setMensajeError("");
    };

    const CambiarTipo = (nuevoTipo) => {
        setTipo(nuevoTipo);
        sessionStorage.setItem(STORAGE_KEY_TIPO, nuevoTipo);
    };

    const filtros = useFiltrosReporteProduccion({
        storageKey: STORAGE_KEY_FILTROS,
        onConsultar: ConsultarReporte,
        onDescargar: DescargarExcel,
    });

    return {
        ...filtros,

        reporteDelTipo: reporte ? reporte[tipo] : null,
        graficaVariacion: reporte ? reporte.grafica_variacion : [],
        graficaMonetaria: reporte ? reporte.grafica_monetaria : [],
        tipo,
        cambiarTipo: CambiarTipo,
        mensajeError,
        limpiarConsulta: LimpiarConsulta,
        cargando,
    };
};
